import Backbone from 'backbone'
import template from './org-selection-form.hbs'
import FormView from 'scoreboard/components/form-view'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import ObjectSelector from 'scoreboard/components/object-selector'

const OrgSelectionForm = Backbone.View.extend({

	tagName: 'form',

	/**
	 * Form that allows for the selection of a single organization
	 * @param {Object} [options.params] extra parameters to append to the URL
	 * used to retrieve the org tree
	 */
	initialize: function(options = {}) {
		this.options = options
		this.section = this.options.section ?? 'organizations'
		this.isSelectOrg = this.section === 'organizations'

		const myFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this.formView = new myFormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.renderSelector()
		this.formView.start()
		return this
	},

	context: function() {
		const titleCodeEnd = this.section == 'organizations' ?
			'selectOrganization' : 'setFile'
		return { title: i18n.get(`common.replication.${titleCodeEnd}`) }
	},

	renderSelector: function() {
		this.selector = new ObjectSelector({
			id: this.options.id,
			projectId: this.options.projectId,
			section: this.section,
			showProjectSelector: this.options.enableProjects,
			preventStandardExpand: true,
			params: this.options.params
		})
		this.$('.selector').append(this.selector.el)
		this.selector.render()
		this.selector.on('select', this.formView.change.bind(this.formView))

		if (this.section === 'organizations') {
			this.$('.org').remove()
			this.$('.object-selector').removeClass('has-two-trees')
			this.$('.object').addClass('is-single-tree-selector')
		}
	},

	test: function() {
		if (_.isNil(this.selector.selected())) {
			return i18n.get('common.select.required')
		}

		return FormView.prototype.test.apply(this, arguments)
	},

	submit: function() {
		const selected = this.selector.selected()
		this.trigger('selected', selected)
	},

	autoRemove: true

})

export default OrgSelectionForm
OrgSelectionForm.__filename__ = 'components/org-selection-form.js'
